import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserContext } from '@hooks/context/useUserContext';
import { EUserRole } from '@xeppt/xeppt-sdk/types';
import { routes } from '@const/routes';

const SuperAdminGuard = () => {
    const { user, isDataLoading } = useUserContext();

    // Hold render until profile is loaded to avoid bouncing a legitimate
    // super-admin on a direct deep-link / page refresh.
    if (isDataLoading || !user) {
        return null;
    }

    if (user.role === EUserRole.SUPER_ADMIN) {
        return <Outlet />;
    }

    return <Navigate to={routes.transactions} replace />;
};

export default SuperAdminGuard;
